export const LOG_PREFIX = '[browser-storage-controls]';
